import ContentPreview from 'components/messagePreview/components/ContentPreview';
import SuggestedActionsPreview from 'components/messagePreview/components/SuggestedActionsPreview';
import { MessageDirection } from 'components/messagePreview/types';
import { RcsMessage } from 'types/rcs';

interface RcsTextPreviewProps {
  direction?: MessageDirection;
  isLoading: boolean;
  message: RcsMessage;
}

const RcsTextPreview = ({
  direction,
  isLoading,
  message,
}: RcsTextPreviewProps) => {
  return (
    <>
      <ContentPreview
        contentPreview={isLoading ? 'Loading...' : message.content}
        direction={direction}
      />
      <SuggestedActionsPreview suggestedActions={message.suggestedActions} />
    </>
  );
};

export default RcsTextPreview;
